import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Alert } from 'antd';
import { Modal, Table, Icon, Loader } from 'react-inv-forms';

import marksActions from '../../../redux/marks/actions';
import { MarksActionTypes, MarksState } from '../../../redux/marks/types';
import { RootState } from '../../../redux/reducers';

import StringBuilder from '../../../helpers/StringBuilder';
import TableCellTypes from '../../../helpers/tableCellTypes';
import columns from './columns';

import fingerPrintIcon from '../../../images/fingerPrintIcon.svg';
import InfoBar from '../../UI/InfoBar/InfoBar';

const { closeSignModal, signMarks } = marksActions;

interface MapStateToProps {
  /** stan dowania */
  loading: MarksState['signing']['loading'];
  /** informacja, czy wystąpił błąd */
  error: MarksState['signing']['error'];
  /** stan otwarcia modala */
  opened: MarksState['signing']['opened'];
  /** lista studentów do podpisania ocen */
  studentList: MarksState['signing']['studentList'];
  /** obiekt przechowujący informacje o szczegółach przedmiotu, dla którego podpisywana jest ocena */
  signing: MarksState['signing'];
}
interface MapDispatchToProps {
  /** akcja zamknięcia modala */
  closeSignModal: () => MarksActionTypes;
  /** akcja rozpoczynająca proces podpisywania ocen */
  signMarks: () => MarksActionTypes;
}
export type Props = MapStateToProps & MapDispatchToProps & WithTranslation;

/**
 *  Komponent modala podpisu ocen
 *
 */
export class SignMarksModal extends React.Component<Props> {
  render(): React.ReactElement {
    const { loading, error, opened, studentList, signing, closeSignModal, signMarks } = this.props;
    const { semestrAkademicki, rokAkademicki, przedmiotKod, wydzialZlecajacyNazwa, przedmiotNazwa } = signing;
    const existNotSignedMark = !!studentList.filter(stud => !stud.ocena).length;
    const barData = {
      semestrAkademicki:
        rokAkademicki && semestrAkademicki ? (
          StringBuilder.buildReadableSemester(Number(rokAkademicki), semestrAkademicki)
        ) : (
          <></>
        ),
      przedmiotKod,
      wydzialZlecajacyNazwa,
      przedmiotNazwa,
    };

    const tableLoading = {
      spinning: loading,
      indicator: <Loader style={{ fontSize: '24px' }} />,
    };

    return (
      <Modal
        visible={opened}
        okText={this.props.t('SIGN_MARKS_MODAL_CONFIRM')}
        cancelText={this.props.t('CANCEL')}
        confirmLoading={loading}
        width='90%'
        title={
          <span>
            <Icon path={fingerPrintIcon} />
            {this.props.t('SIGN_MARKS_MODAL_TITLE')}
          </span>
        }
        onOk={signMarks}
        onCancel={closeSignModal}
        okButtonProps={{ disabled: existNotSignedMark || error || !studentList.length }}
        cancelButtonProps={{ disabled: loading }}
        className='cySignMarksModal'
      >
        {error ? (
          <Alert message={this.props.t('SIGN_MARKS_MODAL_ERROR')} type='error' />
        ) : (
          <>
            <InfoBar content={barData}></InfoBar>
            <Table
              rowKey='albumId'
              tableLayout='auto'
              columns={columns}
              dataSource={TableCellTypes.generateTableContent(studentList, columns)}
              pagination={false}
              loading={tableLoading}
              showSorterTooltip={false}
              scroll={{ x: 'max-content', y: window.outerHeight >= 412 ? 'calc(100vh - 470px)' : '400px' }}
            />
            {existNotSignedMark ? <Alert message={this.props.t('SIGN_MARKS_MODAL_MISSING_FINAL_MARK')} type='error' /> : null}
          </>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  loading: state.Marks.signing.loading,
  opened: state.Marks.signing.opened,
  error: state.Marks.signing.error,
  studentList: state.Marks.signing.studentList,
  signing: state.Marks.signing,
});

const mapDispatchToProps: MapDispatchToProps = {
  closeSignModal,
  signMarks,
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(SignMarksModal) as React.ComponentType<any>;
